var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgE4WcWoman(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 76,
    viewBox: "0 0 76 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M52.19 42.24A2 2 0 0149.07 41l-3-16.62A2 2 0 0044.2 23H43l5 25h-4.51v19.32a2 2 0 01-2.65 1.9 2.06 2.06 0 01-1.35-2V48h-3v19.32a2 2 0 01-2.65 1.9 2.06 2.06 0 01-1.35-2V48H28l5-25h-1.2a2 2 0 00-1.89 1.34L26.93 41a2 2 0 01-3.12 1.28 2.07 2.07 0 01-.8-2.08s3-16.8 3-16.87A6 6 0 0131.8 19h12.4a6 6 0 015.8 4.29v.21l3 16.66a2.07 2.07 0 01-.81 2.08zM41.11 15.9a5 5 0 10-6.194-7.85 5 5 0 006.194 7.85z",
    fill: "currentColor"
  })));
}
export default __webpack_public_path__ + "static/media/E4_WC_woman.e7bc2363.svg";
export { SvgE4WcWoman as ReactComponent };